import React, { useState } from "react";
import { Modal } from "@mui/material";
import close_icon from "../../../assets/crossIcon.svg";
import { Divider } from "@material-ui/core";
import "./scheduleFollowUpModal.css";
import moment from "moment";
import "./index.scss";
import Calendar from "./Calendar";
import { followupReminderPostApi } from "./Api";

export const ScheduleFollowUpModal = ({
  showModalForScheduleFollowUp,
  setShowModalForScheduleFollowUp,
  appointment,
  followUpData,
  setOpenAlert,
  setAlertMsg,
  appointmentsApi,
}) => {
  return (
    <div>
      {showModalForScheduleFollowUp && (
        <MyVerticallyCenteredModal
          appointment={appointment}
          setOpenAlert={setOpenAlert}
          setAlertMsg={setAlertMsg}
          followUpData={followUpData}
          show={showModalForScheduleFollowUp}
          appointmentsApi={appointmentsApi}
          onHide={() => {
            setShowModalForScheduleFollowUp(false);
          }}
        />
      )}
    </div>
  );
};
function MyVerticallyCenteredModal(props) {
  const [calenderDate, setcalenderDate] = useState();
  const [errorText, setErrorText] = useState("");
  const appointment = props.appointment;
  const date =
    props?.followUpData?.FollowUp_Date === "None"
      ? null
      : props?.followUpData?.FollowUp_Date;
  function refreshAppointmentsApi() {
    props.appointmentsApi();
  }
  const handleSubmit = async (flag) => {
    if (flag) {
      const { res, error } = await followupReminderPostApi(
        appointment?.appointment_id,
        moment(calenderDate).format("YYYY-MM-DD")
      );
      if (res) {
        props.setOpenAlert(true);
        props.setAlertMsg("Follow Up Date Added Successfully");

        setTimeout(() => {
          props.setOpenAlert(false);
        }, 2 * 1000);

        refreshAppointmentsApi();
        props.onHide();
      } else if (error === "follow_up_date already completed") {
        setErrorText("Schedule & Follow-Up Already Completed.");
      } else {
        props.onHide();
        refreshAppointmentsApi();
      }
    } else {
      props.onHide();
    }
  };

  return (
    <div id="schedule-follow-div">
      <Modal open={props.show}>
        <div className="schedule-follow-up-container">
          <div className="schedule-follow-up-wrapper">
            <div className="schedule-follow-up-header">
              <h4 id="contained-modal-title-vcenter">Schedule Follow-Up</h4>
              <div
                className="schedule-follow-modal-header-close"
                onClick={props.onHide}
              >
                {window.innerWidth > 767 && "Close"}{" "}
                <img
                  src={close_icon}
                  alt=""
                  style={{
                    width: window.innerWidth > 767 ? "" : "26px",
                    height: window.innerWidth > 767 ? "" : "26px",
                  }}
                />
              </div>
            </div>
            <div>
              <div className="schedule-follow-up-modal-subtitle-body">
                <p className="header-subtitle">
                  Patient will be informed about the follow-up appointment via
                  SMS
                </p>
              </div>
              <Divider />
              <div className="schedule-follow-up-modal-body">
                <p>DETAILS</p>
                <div>
                  <div>Patient Name</div>
                  <div>{appointment?.patient_name}</div>
                </div>
                <div>
                  <div>Mobile Number</div>
                  <div>{appointment?.patient_phone_no}</div>
                </div>
                <div>
                  <div>Appointment Date & Time</div>
                  <div>
                    {moment(appointment?.appointment_date).format(
                      "MMM DD, YYYY"
                    )}
                    {" at "}
                    {moment(
                      appointment?.appointment_start_time
                        ? appointment?.appointment_start_time
                        : props?.followUpData.appointment_date,
                      "hh:mmZ"
                    ).format("hh:mm A")}
                  </div>
                </div>
                <div>
                  <div>Follow - Up Appointment Date</div>
                  <div>
                    {date ? (
                      moment(date).format("MMM DD, YYYY")
                    ) : (
                      <Calendar
                        calenderDate={calenderDate}
                        setcalenderDate={setcalenderDate}
                      />
                    )}
                  </div>
                </div>
                {errorText && (
                  <div className="error-text-color">{errorText}</div>
                )}
              </div>
            </div>
            <div className="schedule-follow-up-button-wrapper d-flex justify-content-center align-items-center">
              <button
                disabled={!date && !calenderDate}
                className="btn btn-sm primary-cta-button rounded-pill py-2 px-3 schedule-follow-up-button"
                onClick={() => handleSubmit(!date && calenderDate)}
              >
                {date ? "Okay" : "Save"}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}
